import React from 'react';
import { Container, Progress, Row, Col } from 'reactstrap';

import { skills } from './skillsData';
import { getPercentage } from '../helpers/helpers';

const Skills = props => {
  return (
    <Container>
      <h3 className='text-center'>Skills</h3>
      <Row>
        {skills.map(skill => (
          <Col className='mb-3' lg={6} md={6} sm={12} key={skill.name}>
            <div>{skill.name}</div>
            <Progress value={getPercentage(skill.rate)}>
              <span className='text-center'>{skill.rate}</span>
            </Progress>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Skills;
